module.exports = __webpack_public_path__ + "static/media/Prompt-S1-Lockup-White.547d8600.svg";